import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';

import App from './App';

import './i18n/config';

// Global needs to come after to overwrite tw headings etc
import './styles/tw.css';
import './styles/global.css';

const container = document.getElementById('root') as Element;

const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
